// Shared motion primitives for portal list pages. Centralizes the
// stagger + fade-and-rise pattern so all list pages animate
// consistently (and so prefers-reduced-motion handling lives one
// place — the MotionConfig in PortalThemeProvider already maps
// reducedMotion="user" → animations short-circuit).
//
// 30-50ms stagger keeps the cascade visible without feeling sluggish;
// child duration 0.28s with easeOut makes the rise feel decisive.
//
// hover lift: subtle translateY + shadow swap. Cards spec
// whileHover={portalCardHover} on motion.article (or wrap a regular
// article with motion.div using these props). Hover lift is suppressed
// for reduced-motion users automatically via MotionConfig.

import type { Variants } from 'framer-motion'

export const portalListVariants: Variants = {
  hidden:  { opacity: 1 },
  visible: { opacity: 1, transition: { when: 'beforeChildren', staggerChildren: 0.04, delayChildren: 0.05 } },
}

export const portalCardVariants: Variants = {
  hidden:  { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.28, ease: 'easeOut' } },
}

// Hover lift — kept gentle so the layout doesn't jump. boxShadow uses
// a token, so it adapts per theme.
export const portalCardHover = {
  y: -2,
  boxShadow: 'var(--shadow-popover-mid)',
  transition: { duration: 0.18, ease: 'easeOut' },
}
